
import { Vue } from "vue-class-component";

export default class CloudUpload extends Vue {}
